import {StrictMode} from 'react'
import {createRoot} from 'react-dom/client'
import './index.css'
import App from './App.jsx'

import * as Sentry from "@sentry/react";

let host = import.meta.env.VITE_HOST;
let port = import.meta.env.VITE_PORT;
Sentry.init({
    dsn: "https://a43d349906559bd5780fc6e07aebb687@o4509054501978112.ingest.de.sentry.io/4509388217057360",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
            networkDetailAllowUrls: [host + ":" + port + '/api/v1'],
            networkRequestHeaders: ['X-Custom-Header'],
            networkResponseHeaders: ['X-Custom-Header'],
        }),
        Sentry.feedbackIntegration({
            colorScheme: "system",
        }),
    ],
    tracesSampleRate: 1.0,

    tracePropagationTargets: ["localhost", /^http:\/\/localhost:8080\/api/],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App/>
    </StrictMode>,
)
